// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mx0N3","left":"styles_left__1X4SP","desktopActions":"styles_desktopActions__164hQ","title":"styles_title__1vCks"};